module.exports = __webpack_public_path__ + "img/steamrolled.4c561ec7.png";